import config from '../config.json'
import { Getter } from '../services/ComService'
import { parseStringToServer, parseStringFromServer } from '../services/TextConverter'
import FileDTO, { IFile } from './FileDTO'

export default class BookPropDTO {
  public id: number
  public key1: string
  public key2: string
  public value1: string
  public value2: string
  public fileId: number = -1
  public file: FileDTO | null = null

  constructor(o: IBookProp) {
    this.id = o.id
    this.key1 = parseStringFromServer(o.key1)
    this.key2 = parseStringFromServer(o.key2)
    this.value1 = parseStringFromServer(o.value1)
    this.value2 = parseStringFromServer(o.value2)
    this.fileId = o.fileId || -1
    this.file = (o.file) ? new FileDTO(o.file) : null
  }

  get() {
    return {
      id: this.id,
      key1: this.key1,
      key2: this.key2,
      value1: this.value1,
      value2: this.value2,
      fileId: this.fileId,
      file: this.file,
    }
  }

  public async remove() {
    await Getter(`admin/BookProp/${this.id}/remove`)
  }

  public setValue1(value: string) {
    this.value1 = value
    this.updateServer()
  }

  public async updateServer() {
    await Getter(`admin/BookProp/${this.id}/${parseStringToServer(this.key1)}/${parseStringToServer(this.key2)}/${parseStringToServer(this.value1)}/${parseStringToServer(this.value2)}`)
  }
}

export interface IBookProp {
  id: number
  key1: string
  key2: string
  value1: string
  value2: string
  fileId?: number
  file?: IFile
}
